<template>
  <div class="hs-tabs-modern">
    <button
      v-for="tab in tabs"
      :key="tab.value || tab.id"
      type="button"
      class="hs-tabs-modern__tab"
      :class="{ 'is-active': isActive(tab) }"
      @click="select(tab)"
    >
      <hs-icon v-if="tab.icon" :name="tab.icon" :size="15" />
      <span>{{ tab.label }}</span>
      <hs-badge v-if="tab.count !== undefined" size="sm" :tone="isActive(tab) ? 'primary' : 'neutral'">
        {{ tab.count }}
      </hs-badge>
    </button>
  </div>
</template>

<script>
import HsBadge from "./HsBadge.vue";
import HsIcon from "./HsIcon.vue";

export default {
  name: "HsTabs",
  components: { HsBadge, HsIcon },
  props: {
    modelValue: { type: [String, Number], default: "" },
    tabs: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue", "change"],
  methods: {
    tabValue(tab) {
      return tab.value ?? tab.id;
    },
    isActive(tab) {
      return String(this.tabValue(tab)) === String(this.modelValue);
    },
    select(tab) {
      const value = this.tabValue(tab);
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style scoped>
.hs-tabs-modern {
  background: color-mix(in srgb, var(--hs-bg-soft, #f1f5f9) 70%, transparent);
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 18px;
  display: flex;
  gap: 0.45rem;
  overflow-x: auto;
  padding: 0.45rem;
}

.hs-tabs-modern__tab {
  align-items: center;
  border-radius: 14px;
  color: var(--hs-muted, #64748b);
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 950;
  gap: 0.45rem;
  min-height: 2.4rem;
  padding: 0 0.85rem;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.hs-tabs-modern__tab:hover {
  color: var(--hs-primary, #3293ec);
}

.hs-tabs-modern__tab.is-active {
  background: var(--hs-surface, #fff);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
  color: var(--hs-primary, #3293ec);
}
</style>
